import { model } from '@zentrains/api';
import { mapToExternalQuelle } from '@/mapper/to-api/quelle';
import { FahrtverlaufIdentifikation, Identifikation } from '@/model/identifikation';

export function mapToExternalIdentifikation(identifikation: Identifikation): model.v3.Identifikation {
  return {
    id: identifikation.id,
    quelle: mapToExternalQuelle(identifikation.quelle),
    startzeit: identifikation.startZeit.valueOf(),
  };
}

export function mapToExternalFahrtverlaufIdentifikation(
  identifikation: FahrtverlaufIdentifikation,
): model.v3.FahrtverlaufIdentifikation {
  return {
    id: identifikation.id,
    quelle: mapToExternalQuelle(identifikation.quelle),
    startzeit: identifikation.startZeit.valueOf(),
    evaNummer: identifikation.evaNummer,
  };
}
